import OfficeDaysForm from 'containers/Layout/forms/OfficeDaysForms';

const OfficeDaysView = () => <OfficeDaysForm />;

export default OfficeDaysView;
